module.exports = __webpack_public_path__ + "static/media/download_app_illustration.baaf0041.svg";